module.exports = __webpack_public_path__ + "static/tip_4-af70963a0bab534755583d72c7f1bf99.jpg";